import { OnboardingFlow } from './shared/onboarding-types';

/**
 * Onboarding flow configuration for Analytics page
 */
export const analyticsOnboarding: OnboardingFlow = {
  id: 'analytics',
  name: 'Analytics Walkthrough',
  steps: [
    {
      id: 'installation-filter',
      element: '[data-testid="installation-selector"]',
      title: 'Filter by installation',
      description:
        'Use this filter to view analytics for a specific installation. This updates all charts and tables on the page.',
      popover: { side: 'bottom', align: 'start' },
    },
    {
      id: 'date-range-filters',
      element: '[data-testid="date-filters-group"]',
      title: 'Filter by date',
      description:
        'Use the date range to control which studies are included in analytics. All metrics update instantly.',
      popover: { side: 'bottom', align: 'start' },
    },
    {
      id: 'ai-solution-table',
      element: '[data-testid="ai-solution-table"]',
      title: 'Drill into an AI solution',
      description:
        'Click an AI solution to see version-specific performance, outcomes, and trends.',
      popover: { side: 'top', align: 'center' },
    },
    {
      id: 'analytics-info',
      element: '[data-testid="analytics-info-button"]',
      title: 'How to read Analytics',
      description:
        'Click here anytime to see explanations for the charts, table, and sections on this page.',
      popover: { side: 'left', align: 'start' },
    },
    {
      id: 'onboarding-user-menu',
      // The user card in the app sidebar's footer, which opens the user menu.
      element: '[data-sidebar="footer"] li:last-child',
      title: 'Onboarding tips',
      description:
        'You can reopen these tips anytime in the user menu - Help.',
      popover: { side: 'top', align: 'start' },
    },
  ],
};
